module.exports = __webpack_public_path__ + "img/013.c277aaed.jpg";